module.exports = __webpack_public_path__ + "img/fi-organic-breakfast-200x132.3e3e5094.jpg";